<template>
  <info-pane-action-btn
    :loading="downloading"
    icon="bx-download"
    :label="label"
    @click="doDownload"
  />
</template>

<script>
import DownloadDocumentFile from '@/mixins/DownloadDocumentFile'
import InfoPaneActionBtn from './InfoPaneActionBtn.vue'

export default {
  name: 'DownloadDocumentBtn',
  components: { InfoPaneActionBtn },
  mixins: [DownloadDocumentFile],
  props: {
    document: { type: Object, required: true },
    label: { type: String, default: 'Download document file' }
  },
  data: function () {
    return {
      downloading: false
    }
  },
  methods: {
    async doDownload() {
      if (this.downloading) {
        return
      }
      this.downloading = true
      await this.downloadDocumentFile(this.document)
      this.downloading = false
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
